import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from 'react-stripe-elements';

import StripeCheckoutForm from './StripeCheckoutForm';

const StripeCheckout = props => (
  <Elements>
    <StripeCheckoutForm
      onSuccess={props.onSuccess}
      name={props.name}
    />
  </Elements>
);

StripeCheckout.propTypes = {
  name: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default StripeCheckout;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Stripe/StripeCheckoutWrapper.js